import React, {useContext, useEffect, useRef, useState} from 'react';
import {useHistory} from "react-router-dom";
import {withRouter} from 'react-router';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import {Col, Container, Row, Form} from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import {getAPI, postAPI} from "../../APIUtil";
import {dateformatJPNByType, nextStatusByApprove, nextStatusByReject, parseDatetime, toNull} from "../../CMUtil";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faForward} from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import {GlobalContext} from "../../Global";

export const ApproveList = ({pPayId, pExpId, pStatus, pOnClickApprove, pOnClickReject}) => {

  const history = useHistory();
  const {loginUser, setLoginUser} = useContext(GlobalContext);

  const iniDispCount = useRef(true);

  const [dispCount, setDispCount] = useState(1);

  const [payId, setPayId] = useState("");
  const [expId, setExpId] = useState("");
  const [status, setStatus] = useState("");
  const [note, setNote] = useState("");
  const [appHistList, setAppHistList] = useState([]);

  useEffect(() => {
    const update = async () => {
      setPayId(pPayId);
      setExpId(pExpId);
      setStatus(pStatus);
      setDispCount(dispCount + 1);
    }
    update();
  }, []);

  useEffect(() => {
    if (iniDispCount.current) {
      iniDispCount.current = false;
      return;
    }
    const update = async () => {
      let searchCondition = {
        order_by: "create_date",
        sort: "desc"
      }
      if(payId){
        searchCondition.pay_id = payId;
      }
      if(expId){
        searchCondition.exp_id = expId;
      }
      let res = await getAPI("tr_app_hist_view", searchCondition);
      setAppHistList(res.results);

    }
    update();
  }, [dispCount]);

  const onClickApprove = async () => {
    //メッセージ登録
    let obj = {};
    obj.pay_id = toNull(payId);
    obj.exp_id = toNull(expId);
    obj.previous_status = status;
    obj.current_status = nextStatusByApprove(status);
    obj.note = note;
    await postAPI("tr_app_hist/", obj);
    pOnClickApprove();
  }

  const onClickReject = async () => {
    //メッセージ登録
    let obj = {};
    obj.pay_id = toNull(payId);
    obj.exp_id = toNull(expId);
    obj.previous_status = status;
    obj.current_status = nextStatusByReject(status);
    obj.note = note;
    await postAPI("tr_app_hist/", obj);
    pOnClickReject();
  }

  return (
    <>
      <Container>
        <Row>
          <Col className="input-group">
            <Form.Control
              id="note"
              as="textarea"
              rows={3}
              value={note}
              style={{fieldSizing: "content"}}
              placeholder="コメント（任意）"
              onChange={e => setNote(e.target.value)}
            />
          </Col>
        </Row>
        <Row className="mt-3">
          {appHistList.length > 0 &&
            <Col>
              <p style={{fontWeight: "bold", marginBottom: "0"}}>承認・差戻し履歴</p>
              <Row className="tbl-h-00">
                <Col className="tbl-h-00-top tbl-h-00-start" sm={3}>
                  日時
                </Col>
                <Col className="tbl-h-00-top" sm={2}>
                  担当
                </Col>
                <Col className="tbl-h-00-top" sm={7}>
                  承認状況
                </Col>
              </Row>
              {appHistList.map((appHist, index2) => (
                <div key={index2}>
                  <Row className="tbl-b-disp-00">
                    <Col lg={3} className="tbl-b-00-start">
                      {
                        dateformatJPNByType(parseDatetime(appHist.create_date.substring(0, 19)), 'year') + "年" +
                        dateformatJPNByType(parseDatetime(appHist.create_date.substring(0, 19)), 'month') + "月" +
                        dateformatJPNByType(parseDatetime(appHist.create_date.substring(0, 19)), 'date') + "日 " +
                        dateformatJPNByType(parseDatetime(appHist.create_date.substring(0, 19)), 'hours') + "時" +
                        dateformatJPNByType(parseDatetime(appHist.create_date.substring(0, 19)), 'minutes') + "分"
                      }
                    </Col>
                    <Col lg={2}>{appHist.create_user.name}</Col>
                    <Col lg={7}>
                      <div className={
                        appHist.previous_status === '新規' ? 'tag-status status-00' :
                          appHist.previous_status === '上長承認中' ? 'tag-status status-01' :
                            appHist.previous_status === '副社長承認中' ? 'tag-status status-10' :
                              appHist.previous_status === '社長承認中' ? 'tag-status status-20' :
                                appHist.previous_status === '支払前' ? 'tag-status status-30' :
                                  appHist.previous_status === '支払済' ? 'tag-status status-90' :
                                    ''
                      }
                           style={{display: "inline-block", textAlign: "center", width: "130px"}}>
                        {appHist.previous_status}
                      </div>
                      <FontAwesomeIcon icon={faForward} size="sm" style={{margin: "0 20px"}}/>
                      <div className={
                        appHist.current_status === '新規' ? 'tag-status status-00' :
                          appHist.current_status === '上長承認中' ? 'tag-status status-01' :
                            appHist.current_status === '副社長承認中' ? 'tag-status status-10' :
                              appHist.current_status === '社長承認中' ? 'tag-status status-20' :
                                appHist.current_status === '支払前' ? 'tag-status status-30' :
                                  appHist.current_status === '支払済' ? 'tag-status status-90' :
                                    ''
                      }
                           style={{display: "inline-block", textAlign: "center", width: "130px"}}>
                        {appHist.current_status}
                      </div>
                      <div style={{margin: "10px 0"}}>
                        {appHist.note}
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}
            </Col>
          }
        </Row>
        <Row style={{width: "100%"}}>
          <Col className="text-left">
            {
              (
                (loginUser.dept === 'システム') ||
                (status === '上長承認中' && loginUser.dept === '上長') ||
                (status === '副社長承認中' && loginUser.dept === '副社長') ||
                (status === '社長承認中' && loginUser.dept === '社長') ||
                (status === '支払前' && loginUser.dept === '経理')
              ) &&
              <Button variant="tertiary" onClick={e => onClickReject()}>
                差戻し
              </Button>
            }
          </Col>
          <Col className="text-right">
            {
              (
                (loginUser.dept === 'システム') ||
                (status === '新規' && loginUser.dept === '編集') ||
                (status === '上長承認中' && loginUser.dept === '上長') ||
                (status === '副社長承認中' && loginUser.dept === '副社長') ||
                (status === '社長承認中' && loginUser.dept === '社長') ||
                (status === '支払前' && loginUser.dept === '経理')
              ) &&

              <Button variant="primary" onClick={e => onClickApprove()}>
                {
                  status === '新規' &&
                  <>申請</>
                }
                {
                  (
                    status === '上長承認中' ||
                    status === '副社長承認中' ||
                    status === '社長承認中' ||
                    status === '支払前'
                  ) &&
                  <>承認</>
                }
              </Button>
            }
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default withRouter(ApproveList);